module.exports = __webpack_public_path__ + "static/CaviarDreams_BoldItalic-webfont-c8490a88ad978d51d0cd6ffa86590d27.woff";